import React from 'react';
import Link from 'next/link';

import Atv from 'react-scale/components/elements/atv';
import Section from 'react-scale/components/elements/section';
import SectionTitle from 'react-scale/components/elements/section-title';

const Team = ({ teamTitle }) => (
  <Section id="stories" bg="bg-neutral-50">
    <SectionTitle
      overtitle={teamTitle.overtitle}
      title={teamTitle.title}
      subtitle={teamTitle.subtitle}
      theme="light"
    />
    <div className="grid gap-5 mx-auto sm:max-w-1/2 md:max-w-none md:grid-cols-3">
      <div>
        <Link href="/blog/why-I-joined-scale-sophia">
          <div className="flex flex-col items-center" style={{ transform: 'translateZ(0)' }}>
            <Atv
              layers={[
                '/static/images/pages/careers/gradient-background.svg',
                '/static/images/pages/careers/team/sophia-bw.png'
              ].filter(layer => layer !== undefined)}
              staticFallback="http://kloc.pm/images/kloc-icon-flattened.jpg"
              style={{ width: '100%', height: '240px' }}
            />
            <span className="mt-3 text-base font-normal text-neutral-900">Sophia Luo</span>
            <span className="mt-1 text-sm font-normal text-neutral-700">
              Engineering & Product Manager
            </span>
          </div>
        </Link>
      </div>
      <div>
        <Link href="/blog/scale-cto">
          <div className="flex flex-col items-center" style={{ transform: 'translateZ(0)' }}>
            <Atv
              layers={[
                '/static/images/pages/careers/gradient-background.svg',
                '/static/images/pages/careers/team/arun-murthy.png'
              ].filter(layer => layer !== undefined)}
              staticFallback="http://kloc.pm/images/kloc-icon-flattened.jpg"
              style={{ width: '100%', height: '240px' }}
            />
            <span className="mt-3 text-base font-normal text-neutral-900">Arun Murthy</span>
            <span className="mt-1 text-sm font-normal text-neutral-700">
              Chief Product & Technology Officer
            </span>
          </div>
        </Link>
      </div>
      <div>
        <Link href="/blog/scale-john-brennan-general-manager-public-sector">
          <div className="flex flex-col items-center" style={{ transform: 'translateZ(0)' }}>
            <Atv
              layers={[
                '/static/images/pages/careers/gradient-background.svg',
                '/static/images/pages/careers/team/john-brennan.png'
              ].filter(layer => layer !== undefined)}
              staticFallback="http://kloc.pm/images/kloc-icon-flattened.jpg"
              style={{ width: '100%', height: '240px' }}
            />
            <span className="mt-3 text-base font-normal text-neutral-900">John Brennan</span>
            <span className="mt-1 text-sm font-normal text-neutral-700">General Manager</span>
          </div>
        </Link>
      </div>
    </div>
  </Section>
);

export default Team;
